/* Banky Nieuw WP6.1: vergelijken (Keuzebord #66 vergelijkbalk en #67 vergelijkpagina).
   Logica van Banky Scratch, vorm en tekst van de andere versie (A). Alle klanttekst komt uit de locales (Liquid zet
   hem in data-attributen of in de JSON van de pagina); dit bestand bevat geen Nederlandse zinnen.
   - Vinkje "Vergelijk" op de productkaart (input[data-banky-compare], WP1.4): tot 3 powerbanks, bewaard onder
     banky.compare.v1 (localStorage, in try/catch), melding bij een vierde.
   - <banky-compare-tray>: witte glaspil onderaan met miniaturen, "2 van 3" en Vergelijk; de link naar de
     vergelijkpagina met ?p=a,b,c wordt hier gebouwd (geen parameterlinks in de HTML). Verborgen zolang de koopbox in
     beeld is en als er een lade of menu open is.
   - <banky-vergelijk>: de vergelijkpagina. Kolommen wisselen, toevoegen en weghalen uit de sjablonen per powerbank
     (Liquid, snippet banky-compare-column), een rij alleen als elke gekozen powerbank een waarde heeft, beste waarde
     per rij, "Toon alleen verschillen", meelopende kolomkop, keuze in de link (?p=) en in de vergelijkbalk. */
(() => {
  if (window.BankyVergelijken) return;
  const SLEUTEL = 'banky.compare.v1';
  const MAX = 3;
  // Vanaf dit vermogen laadt een powerbank een laptop (gelijk aan de keuzehulp, laptop_min_w in banky-finder-data).
  const LAPTOP_W = 30;
  const HANDLE = /^[a-z0-9][a-z0-9-]{0,120}$/;
  const VINK = 'input[type="checkbox"][data-banky-compare]';

  const leesKeuze = () => {
    try {
      const v = JSON.parse(localStorage.getItem(SLEUTEL) || '[]');
      if (!Array.isArray(v)) return [];
      const gezien = new Set();
      return v.filter(x => x && HANDLE.test(x.handle || '') && !gezien.has(x.handle) && gezien.add(x.handle)).slice(0, MAX);
    } catch (e) { return []; }
  };
  const schrijfKeuze = lijst => {
    try { localStorage.setItem(SLEUTEL, JSON.stringify(lijst.slice(0, MAX))); } catch (e) { /* privé venster: alleen deze pagina */ }
    document.dispatchEvent(new CustomEvent('banky:vergelijk', {detail: {lijst: lijst.slice(0, MAX)}}));
  };
  const vul = (tekst, waarde) => String(tekst || '').replace('__N__', waarde);

  // Productfoto van de kaart als miniatuur (Shopify-CDN: kleinere breedte).
  const beeldVan = vink => {
    const kaart = vink.closest('product-card, .product-card');
    const img = kaart && kaart.querySelector('.product-card__figure img, img');
    const src = img ? (img.currentSrc || img.getAttribute('src') || '') : '';
    return src ? src.replace(/([?&])width=\d+/, '$1width=96') : '';
  };

  const synchroniseer = () => {
    const gekozen = new Set(leesKeuze().map(x => x.handle));
    document.querySelectorAll(VINK).forEach(v => { v.checked = gekozen.has(v.dataset.bankyCompare); });
  };

  /* ---------------- Vergelijkbalk ---------------- */
  class BankyCompareTray extends HTMLElement {
    connectedCallback() {
      if (this.klaar) return;
      this.klaar = true;
      this.duimen = this.querySelector('[data-banky-compare-duimen]');
      this.tekst = this.querySelector('[data-banky-compare-tekst]');
      this.knop = this.querySelector('[data-banky-compare-knop]');
      this.meldingVak = this.querySelector('[data-banky-compare-melding]');
      this.koopboxInBeeld = false;
      this.querySelector('[data-banky-compare-wis]')?.addEventListener('click', () => {
        schrijfKeuze([]);
        (document.querySelector(VINK) || document.body).focus?.({preventScroll: true});
      });
      this.knop?.addEventListener('click', e => { if (this.knop.getAttribute('aria-disabled') === 'true') e.preventDefault(); });
      // Elke wijziging van de keuze wist de melding (eindronde extras): na een vierde vinkje en dan één uit staat er
      // meteen weer "2 van 3", niet nog 3 s de melding.
      document.addEventListener('banky:vergelijk', () => { this.wisMelding(); this.toon(); });
      // Productpagina: niet zolang de koopbox in beeld is (Scratch-logica).
      const koopbox = document.body.classList.contains('template-product') ? document.querySelector('[data-banky-koopbox], .product-info') : null;
      if (koopbox && 'IntersectionObserver' in window) {
        this.koopboxInBeeld = true;
        new IntersectionObserver(([e]) => { this.koopboxInBeeld = e.isIntersecting; this.toon(); }, {threshold: 0}).observe(koopbox);
      }
      this.hidden = false;
      this.toon();
    }

    // De melding (maximaal 3) staat in een eigen vak boven de balk, naast de teller en de knop Vergelijk, niet in
    // plaats daarvan (eindronde extras, 01-10-2026; op 390 was de knop 3 s weg).
    melding(tekst) {
      this.toon();
      if (!this.meldingVak) return;
      this.meldingVak.textContent = tekst;
      this.classList.add('is-melding');
      this.zichtbaar(true);
      clearTimeout(this.meldingTimer);
      this.meldingTimer = setTimeout(() => { this.wisMelding(); this.toon(); }, 3200);
    }

    wisMelding() {
      clearTimeout(this.meldingTimer);
      if (!this.classList.contains('is-melding')) return;
      this.classList.remove('is-melding');
      if (this.meldingVak) this.meldingVak.textContent = '';
    }

    zichtbaar(aan) {
      this.classList.toggle('is-zichtbaar', aan);
      this.toggleAttribute('inert', !aan);
      if (aan) this.removeAttribute('aria-hidden'); else this.setAttribute('aria-hidden', 'true');
    }

    toon() {
      const lijst = leesKeuze();
      this.duimen.replaceChildren(...lijst.map(x => {
        const vak = document.createElement('span');
        vak.className = 'banky-compare-bar__duim';
        if (x.beeld) {
          const img = document.createElement('img');
          img.src = x.beeld; img.alt = ''; img.width = 36; img.height = 36; img.loading = 'lazy'; img.decoding = 'async';
          vak.append(img);
        }
        return vak;
      }));
      const een = lijst.length === 1;
      this.classList.toggle('is-een', een);
      this.tekst.textContent = een ? this.dataset.nogEen : vul(this.dataset.aantal, lijst.length);
      if (lijst.length >= 2) {
        this.knop.href = this.dataset.url + '?p=' + lijst.map(x => encodeURIComponent(x.handle)).join(',');
        this.knop.removeAttribute('aria-disabled');
        this.knop.removeAttribute('role');
      } else {
        this.knop.removeAttribute('href');
        this.knop.setAttribute('role', 'link');
        this.knop.setAttribute('aria-disabled', 'true');
      }
      this.zichtbaar(this.classList.contains('is-melding') || (lijst.length > 0 && !this.koopboxInBeeld));
    }
  }

  document.addEventListener('change', e => {
    const vink = e.target.closest && e.target.closest(VINK);
    if (!vink) return;
    const handle = vink.dataset.bankyCompare;
    if (!HANDLE.test(handle || '')) return;
    let lijst = leesKeuze().filter(x => x.handle !== handle);
    if (vink.checked) {
      if (lijst.length >= MAX) {
        vink.checked = false;
        const balk = document.querySelector('banky-compare-tray');
        if (balk && balk.melding) balk.melding(balk.dataset.max);
        return;
      }
      lijst.push({handle, titel: vink.dataset.bankyCompareTitel || '', beeld: beeldVan(vink)});
    }
    schrijfKeuze(lijst);
  });
  document.addEventListener('banky:vergelijk', synchroniseer);
  addEventListener('storage', e => { if (e.key === SLEUTEL) document.dispatchEvent(new CustomEvent('banky:vergelijk')); });
  addEventListener('pageshow', e => { if (e.persisted) document.dispatchEvent(new CustomEvent('banky:vergelijk')); });
  // Kaarten die later verschijnen (filters, lades, rails) krijgen hun vinkje terug.
  let wacht = 0;
  const metVinkje = n => n.nodeType === 1 && (n.matches(VINK) || !!n.querySelector(VINK));
  new MutationObserver(lijst => {
    if (wacht || !lijst.some(m => [...m.addedNodes].some(metVinkje))) return;
    wacht = requestAnimationFrame(() => { wacht = 0; synchroniseer(); });
  }).observe(document.documentElement, {childList: true, subtree: true});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', synchroniseer); else synchroniseer();

  /* ---------------- Vergelijkpagina ---------------- */
  const RIJ_BESTE = {max: 1, min: -1};
  const tekstVan = el => (el ? el.textContent.replace(/\s+/g, ' ').trim() : '');

  class BankyVergelijk extends HTMLElement {
    connectedCallback() {
      if (this.klaar) return;
      const bron = this.querySelector('[data-banky-vergelijk-data]');
      if (!bron) return;
      try { this.data = JSON.parse(bron.textContent); } catch (e) { return; }
      this.klaar = true;
      this.producten = new Map(this.data.producten.map(p => [p.handle, p]));
      this.sjablonen = new Map([...this.querySelectorAll('template[data-banky-vergelijk-product]')].map(t => [t.dataset.bankyVergelijkProduct, t.content]));
      this.nieuwSjabloon = this.querySelector('template[data-banky-vergelijk-nieuw]')?.content;
      this.koppen = this.querySelector('[data-banky-vergelijk-koppen]');
      this.schuif = this.querySelector('[data-banky-vergelijk-schuif]');
      this.plak = this.querySelector('[data-banky-vergelijk-plak]');
      this.plakRij = this.querySelector('[data-banky-vergelijk-plakrij]');
      this.status = this.querySelector('[data-banky-vergelijk-status]');
      this.telling = this.querySelector('[data-banky-vergelijk-telling]');
      this.verschil = this.querySelector('[data-banky-vergelijk-verschil]');
      this.t = this.data.teksten || {};
      // Beste-teken in de cel (mobiel en tablet), een kopie van het teken in de legenda (icoon uit Liquid).
      const teken = this.querySelector('.banky-vergelijk__beste-teken');
      if (teken) {
        this.besteTeken = teken.cloneNode(true);
        this.besteTeken.classList.add('banky-vergelijk__beste-teken--cel');
        this.besteTeken.setAttribute('aria-hidden', 'true');
      }

      // Kolommen in de kop en in elke rij: altijd drie plekken (twee powerbanks plus de lege kolom, of drie).
      for (let i = 0; i < MAX; i++) {
        if (!this.koppen.querySelector(`[data-kolom="${i}"]`)) this.koppen.append(this.maak('div', {role: 'columnheader', class: 'banky-vergelijk__kolom', 'data-kolom': i}));
        this.querySelectorAll('.banky-vergelijk__rij[data-rij]').forEach(rij => {
          if (!rij.querySelector(`[data-kolom="${i}"]`)) rij.append(this.maak('div', {role: 'cell', class: 'banky-vergelijk__cel', 'data-kolom': i}));
        });
      }

      // Keuze: eerst de link (?p=), dan de vergelijkbalk, anders de bestsellers van de pagina.
      const geldig = lijst => [...new Set(lijst)].filter(h => this.producten.has(h)).slice(0, MAX);
      let p = [];
      try { p = (new URLSearchParams(location.search).get('p') || '').split(',').map(h => h.trim().toLowerCase()).filter(h => HANDLE.test(h)); } catch (e) { p = []; }
      let keuze = geldig(p);
      this.eigen = keuze.length >= 2;
      if (!this.eigen) {
        const balk = geldig(leesKeuze().map(x => x.handle));
        if (balk.length >= 2) { keuze = balk; this.eigen = true; }
      }
      if (keuze.length < 2) {
        const aanvulling = [...(this.data.standaard || []), ...this.data.producten.filter(x => x.beschikbaar).map(x => x.handle)];
        for (const h of aanvulling) { if (keuze.length >= MAX) break; if (this.producten.has(h) && !keuze.includes(h)) keuze.push(h); }
      }
      this.keuze = keuze;

      this.querySelectorAll('[data-banky-vergelijk-js]').forEach(el => { el.hidden = false; });
      this.addEventListener('change', e => this.bijWijziging(e));
      this.addEventListener('click', e => this.bijKlik(e));
      this.schuif?.addEventListener('scroll', () => this.spiegel(), {passive: true});
      // Na elke scroll nog twee frames meten: de kop begint zijn beweging soms in hetzelfde frame, na deze meting.
      this.plakTik = 0;
      this.plakNa = 0;
      const plakCheck = () => { this.plakNa = 2; this.plakPlan(); };
      addEventListener('scroll', plakCheck, {passive: true});
      addEventListener('resize', plakCheck, {passive: true});
      this.vul();
      this.werkBij({aankondigen: false});
      this.plakBalk();
    }

    maak(tag, attrs = {}) {
      const el = document.createElement(tag);
      for (const [k, v] of Object.entries(attrs)) el.setAttribute(k, v);
      return el;
    }

    deel(h, selector) {
      const s = this.sjablonen.get(h);
      const bron = s && s.querySelector(selector);
      return bron ? [...bron.childNodes].map(n => document.importNode(n, true)) : [];
    }

    // WP r1-rekenhulp.1 (RAPPORT A5): een cel met alleen witruimte of een leeg element telt niet als waarde, anders
    // staat een rij als Waterbescherming leeg in beeld.
    heeftWaarde(h, rij) {
      const s = this.sjablonen.get(h);
      const cel = s && s.querySelector(`[data-cel="${rij}"]`);
      return !!(cel && cel.children.length && cel.textContent.trim());
    }

    // Eindronde product (01-10-2026): modellen met dezelfde kaarttitel (de twee "Powerbank 30.000 mAh") krijgen A's
    // kaartregel erbij ("Powerbank 30.000 mAh · Tot 22,5W · USB-C"), anders staan er twee gelijke opties in de lijst.
    dubbeleTitels(handles) {
      const tel = new Map();
      handles.forEach(h => { const t = this.producten.get(h)?.titel; if (t) tel.set(t, (tel.get(t) || 0) + 1); });
      return new Set([...tel].filter(([, n]) => n > 1).map(([t]) => t));
    }

    // Opties van een keuzelijst: op voorraad en uitverkocht apart, de gekozen powerbank geselecteerd.
    opties(select, huidig, zonder = []) {
      const dubbel = this.dubbeleTitels(this.data.producten.map(p => p.handle));
      const naam = p => (dubbel.has(p.titel) && p.detail ? `${p.titel} · ${p.detail}` : p.titel);
      const groep = (label, lijst) => {
        if (!lijst.length) return null;
        const g = this.maak('optgroup', {label});
        lijst.forEach(p => { const o = new Option(naam(p), p.handle, false, p.handle === huidig); g.append(o); });
        return g;
      };
      const vrij = this.data.producten.filter(p => p.handle === huidig || !zonder.includes(p.handle));
      const delen = [];
      if (!huidig) { const o = new Option(this.t.toevoegen || '', '', true, true); o.disabled = true; delen.push(o); }
      delen.push(groep(this.t.op_voorraad, vrij.filter(p => p.beschikbaar)), groep(this.t.uitverkocht, vrij.filter(p => !p.beschikbaar)));
      select.replaceChildren(...delen.filter(Boolean));
    }

    // Drie powerbanks op voorraad als knoppen (Geert 29-10-2026: "bij 2 laptop powerbanks weergeeft ie nu opties voor
    // capaciteit bijvoorbeeld. ipv een 3e laptop powerbank te laten zien. eerst proberen te laten zien uit zelfde collectie
    // of vergelijkbaar product"). Eerst dezelfde soort als de meeste gekozen powerbanks (producttype, zoals de collecties),
    // dan vergelijkbaar: wat alle gekozen powerbanks gemeen hebben (laptop laden vanaf 30W, buiten met zonnepaneel of
    // zaklamp, MagSafe of draadloos, compact tot 10.000 mAh), dan de capaciteit. Binnen dezelfde soort de volgorde van de
    // collectie (best verkocht); daarbuiten eerst de meeste gedeelde kenmerken, dan de dichtstbijzijnde capaciteit (bij
    // twee MagSafe powerbanks dus eerst de mini, niet een solar powerbank die ook draadloos laadt).
    voorstellen(lijst) {
      const gekozen = this.keuze.map(h => this.producten.get(h)).filter(Boolean);
      const gemiddeld = gekozen.reduce((a, p) => a + (p.mah || 0), 0) / Math.max(1, gekozen.length);
      const tel = new Map();
      gekozen.forEach(p => { if (p.soort) tel.set(p.soort, (tel.get(p.soort) || 0) + 1); });
      // De soort die het vaakst gekozen is; bij gelijk aantal die van de eerste kolom.
      let soort = '';
      gekozen.forEach(p => { if (p.soort && (!soort || tel.get(p.soort) > tel.get(soort))) soort = p.soort; });
      const kenmerken = p => {
        const f = p.functies || '', k = new Set();
        if ((p.w || 0) >= LAPTOP_W) k.add('laptop');
        if (/solar|zaklamp/.test(f)) k.add('buiten');
        if (/magsafe|draadloos/.test(f)) k.add('draadloos');
        if (p.mah > 0 && p.mah <= 10000) k.add('compact');
        return k;
      };
      const sets = gekozen.map(kenmerken);
      const gedeeld = sets.length ? [...sets[0]].filter(k => sets.every(s => s.has(k))) : [];
      const overlap = p => { const k = kenmerken(p); return gedeeld.filter(x => k.has(x)).length; };
      const volgorde = new Map(this.data.producten.map((p, i) => [p.handle, i]));
      const zelfde = p => (soort && p.soort === soort ? 0 : 1);
      const kandidaten = this.data.producten.filter(p => p.beschikbaar && !this.keuze.includes(p.handle))
        .sort((a, b) => zelfde(a) - zelfde(b) || overlap(b) - overlap(a)
          || (zelfde(a) === 0 ? 0 : Math.abs(a.mah - gemiddeld) - Math.abs(b.mah - gemiddeld))
          || volgorde.get(a.handle) - volgorde.get(b.handle))
        .slice(0, 3);
      // Kop boven de voorstellen: de soort als ze er allemaal bij horen (bijv. "Laptop powerbanks"), anders "Vergelijkbare
      // powerbanks". De algemene soort "Powerbanks" zegt niets extra, dan ook de algemene kop.
      const label = lijst.parentElement?.querySelector('.banky-vergelijk__nieuw-label');
      if (label) {
        const zelfde = soort && soort.toLowerCase() !== 'powerbanks' && kandidaten.length && kandidaten.every(p => p.soort === soort);
        label.textContent = zelfde ? soort : (this.t.dichtbij || label.textContent);
      }
      lijst.replaceChildren(...kandidaten.map(p => {
        const li = document.createElement('li');
        const knop = this.maak('button', {type: 'button', class: 'banky-vergelijk__voorstel', 'data-banky-vergelijk-voeg': p.handle});
        knop.append(...this.deel(p.handle, '[data-deel="mini"]'));
        li.append(knop);
        return li;
      }));
    }

    // Kolommen vullen uit de sjablonen.
    vul() {
      const n = this.keuze.length;
      const dubbel = this.dubbeleTitels(this.keuze);
      for (let i = 0; i < MAX; i++) {
        const h = this.keuze[i];
        const kop = this.koppen.querySelector(`[data-kolom="${i}"]`);
        const cellen = this.querySelectorAll(`.banky-vergelijk__rij[data-rij] > [data-kolom="${i}"]`);
        const plak = this.plakRij?.querySelector(`[data-kolom="${i}"]`);
        if (h) {
          kop.replaceChildren(...this.deel(h, '[data-deel="kop"]'));
          kop.setAttribute('role', 'columnheader');
          kop.dataset.handle = h;
          const p = this.producten.get(h);
          let onder = null;
          if (p && p.detail && dubbel.has(p.titel)) {
            onder = this.maak('span', {class: 'banky-vergelijk__onderscheid'});
            onder.textContent = p.detail;
            kop.querySelector('.banky-vergelijk__titel')?.after(onder);
          }
          cellen.forEach(cel => cel.replaceChildren(...this.deel(h, `[data-cel="${cel.parentElement.dataset.rij}"]`)));
          if (plak) plak.replaceChildren(...this.deel(h, '[data-deel="mini"]'));
          // Geert 02-10 ("maak beter"): het onderscheid ook in de meelopende kop, anders staat daar twee keer
          // "Powerbank 30.000 mAh". Zelfde klasse als onder de kolomkop.
          if (plak && onder) plak.querySelector('.banky-vergelijk__mini-titel')?.after(onder.cloneNode(true));
          const titel = this.producten.get(h).titel;
          const select = kop.querySelector('[data-banky-vergelijk-kies]');
          if (select) { this.opties(select, h); select.setAttribute('aria-label', vul(this.t.wissel_label, i + 1)); }
          kop.querySelector('[data-banky-vergelijk-acties]')?.removeAttribute('hidden');
          const weg = kop.querySelector('[data-banky-vergelijk-weg]');
          if (weg) { weg.hidden = n <= 2; weg.setAttribute('aria-label', vul(this.t.verwijder, titel)); }
        } else if (i === n && this.nieuwSjabloon) {
          kop.replaceChildren(document.importNode(this.nieuwSjabloon, true));
          kop.setAttribute('role', 'cell');
          delete kop.dataset.handle;
          const select = kop.querySelector('[data-banky-vergelijk-kies]');
          if (select) this.opties(select, '', this.keuze);
          const lijst = kop.querySelector('[data-banky-vergelijk-voorstellen]');
          if (lijst) this.voorstellen(lijst);
          cellen.forEach(cel => cel.replaceChildren());
          if (plak) plak.replaceChildren();
        } else {
          kop.replaceChildren();
          cellen.forEach(cel => cel.replaceChildren());
          if (plak) plak.replaceChildren();
        }
      }
    }

    // Rijen tonen of verbergen, beste waarde per rij, telling.
    werkBij({aankondigen = true} = {}) {
      const alleenVerschil = !!(this.verschil && this.verschil.checked);
      let verschillen = 0;
      this.querySelectorAll('.banky-vergelijk__groep').forEach(groep => {
        let zichtbaar = 0;
        groep.querySelectorAll('.banky-vergelijk__rij[data-rij]').forEach(rij => {
          const sleutel = rij.dataset.rij;
          const compleet = this.keuze.every(h => this.heeftWaarde(h, sleutel));
          const cellen = this.keuze.map((h, i) => rij.querySelector(`[data-kolom="${i}"]`));
          // Eerst de markering van de vorige ronde weg, zodat die niet meetelt bij "gelijk".
          rij.querySelectorAll('.banky-vergelijk__cel').forEach(c => { c.classList.remove('is-beste'); c.querySelectorAll('.banky-vergelijk__beste-sr, .banky-vergelijk__beste-teken--cel').forEach(x => x.remove()); });
          const gelijk = compleet && new Set(cellen.map(tekstVan)).size === 1;
          if (compleet && !gelijk) verschillen++;
          rij.hidden = !compleet || (alleenVerschil && gelijk && !rij.hasAttribute('data-banky-r1-required'));
          if (!rij.hidden) zichtbaar++;
          const richting = RIJ_BESTE[rij.dataset.beste];
          if (!compleet || !richting) return;
          const waarden = cellen.map(c => { const v = parseFloat(c?.querySelector('[data-v]')?.dataset.v); return Number.isFinite(v) ? v : null; });
          const getallen = waarden.filter(v => v !== null);
          if (getallen.length < 2 || new Set(getallen).size < 2) return;
          const doel = richting > 0 ? Math.max(...getallen) : Math.min(...getallen);
          // Handbagage: alleen "Mag mee in handbagage" is een pluspunt, niet de minst slechte van de rest.
          if (rij.dataset.besteVanaf && doel < Number(rij.dataset.besteVanaf)) return;
          // Eindronde extras (01-10-2026): met data-beste-marge (procent) telt een waarde binnen die marge van de beste
          // als even goed (€9,98 en €9,99 per 10.000 mAh zijn voor de klant gelijk). Ligt alles binnen de marge, dan
          // krijgt de rij geen markering; anders krijgen alle waarden binnen de marge hem.
          const marge = Math.max(0, Number(rij.dataset.besteMarge) || 0) / 100;
          const binnenMarge = v => v !== null && Math.abs(v - doel) <= Math.abs(doel) * marge + 1e-9;
          if (marge && getallen.every(binnenMarge)) return;
          waarden.forEach((v, i) => {
            if (marge ? !binnenMarge(v) : v !== doel) return;
            cellen[i].classList.add('is-beste');
            // Geert 02-10 ("iconen en inhoud lopen door elkaar"): op mobiel en tablet staat het teken direct achter de
            // waarde. Vooraan schoof het de tekst op; rechts in de hoek van de cel stond het 12px voor de waarde van de
            // volgende kolom en leek het daarbij te horen. Desktop houdt het teken vooraan (CSS).
            const w = cellen[i].querySelector('.banky-vergelijk__waarde');
            if (this.besteTeken && w && w.tagName !== 'UL') {
              const t = this.besteTeken.cloneNode(true);
              const onder = w.querySelector('.banky-vergelijk__minimaal');
              // Controle 03-10: vóór de witruimte uit de bron (Handbagage), anders stond het teken 9 tot 10px in plaats
              // van 6px achter de tekst. De witruimte zelf blijft staan.
              let na = w.lastChild;
              while (na && na.nodeType === 3 && !na.textContent.trim()) na = na.previousSibling;
              if (onder) onder.before(t); else if (na) na.after(t); else w.append(t);
            }
            const sr = this.maak('span', {class: 'sr-only banky-vergelijk__beste-sr'});
            sr.textContent = ' (' + (this.t.beste_sr || '') + ')';
            cellen[i].append(sr);
          });
        });
        groep.hidden = zichtbaar === 0;
      });
      if (this.telling) {
        const n = this.maak('span', {class: 'banky-vergelijk__telling-n'});
        n.textContent = vul(this.t.naast_elkaar, this.keuze.length);
        const v = verschillen === 0 ? this.t.geen_verschillen : verschillen === 1 ? this.t.verschil : vul(this.t.verschillen, verschillen);
        const sep = this.maak('span', {class: 'banky-vergelijk__telling-sep', 'aria-hidden': 'true'});
        sep.textContent = ' · ';
        this.telling.replaceChildren(n, sep, document.createTextNode(v));
      }
      if (aankondigen && this.status) {
        const namen = this.keuze.map(h => this.producten.get(h).titel);
        const lijst = namen.length > 1 ? namen.slice(0, -1).join(', ') + ' ' + (this.t.en || '') + ' ' + namen[namen.length - 1] : namen[0] || '';
        this.status.textContent = vul(this.t.nu, lijst);
      }
      this.spiegel();
    }

    bewaar() {
      this.eigen = true;
      try { history.replaceState(history.state, '', (this.dataset.url || location.pathname) + '?p=' + this.keuze.map(encodeURIComponent).join(',')); } catch (e) { /* geen history */ }
      schrijfKeuze(this.keuze.map(h => { const p = this.producten.get(h); return {handle: h, titel: p.titel, beeld: p.beeld}; }));
    }

    herteken(focusKolom) {
      this.vul();
      this.werkBij();
      this.bewaar();
      if (focusKolom != null) {
        const kop = this.koppen.querySelector(`[data-kolom="${Math.min(focusKolom, this.keuze.length)}"]`);
        kop?.querySelector('[data-banky-vergelijk-kies]')?.focus({preventScroll: true});
      }
    }

    bijWijziging(e) {
      if (e.target === this.verschil) { this.werkBij({aankondigen: false}); return; }
      const select = e.target.closest('[data-banky-vergelijk-kies]');
      if (!select) return;
      const kolom = Number(select.closest('[data-kolom]')?.dataset.kolom);
      const h = select.value;
      if (!this.producten.has(h) || !Number.isInteger(kolom)) return;
      const staat = this.keuze.indexOf(h);
      if (kolom >= this.keuze.length) { if (staat === -1 && this.keuze.length < MAX) this.keuze.push(h); }
      else if (staat !== -1 && staat !== kolom) { [this.keuze[kolom], this.keuze[staat]] = [this.keuze[staat], this.keuze[kolom]]; }
      else this.keuze[kolom] = h;
      this.herteken(kolom);
    }

    bijKlik(e) {
      const voeg = e.target.closest('[data-banky-vergelijk-voeg]');
      if (voeg) {
        const h = voeg.dataset.bankyVergelijkVoeg;
        if (this.producten.has(h) && !this.keuze.includes(h) && this.keuze.length < MAX) { this.keuze.push(h); this.herteken(this.keuze.length - 1); }
        return;
      }
      const weg = e.target.closest('[data-banky-vergelijk-weg]');
      if (weg && this.keuze.length > 2) {
        const kolom = Number(weg.closest('[data-kolom]')?.dataset.kolom);
        if (!Number.isInteger(kolom)) return;
        this.keuze.splice(kolom, 1);
        this.herteken(Math.max(0, kolom - 1));
      }
    }

    plakPlan() {
      if (!this.plakTik) this.plakTik = requestAnimationFrame(() => { this.plakTik = 0; this.plakBalk(); });
    }

    // Meelopende kolomkop zodra de productnamen onder de kop schuiven, tot het eind van de tabel.
    plakBalk() {
      if (!this.plak || !this.koppen) return;
      // Onder de zwevende kop zolang die in beeld is; die verdwijnt bij omlaag scrollen, dan bovenaan.
      // De kop schuift het element store-header zelf weg (transform); de sectie eromheen blijft staan.
      const header = document.querySelector('.shopify-section--header store-header, .shopify-section--header .header') || document.querySelector('.shopify-section--header');
      const boven = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
      this.plak.style.setProperty('--banky-vergelijk-boven', boven + 'px');
      // Geert 02-10 ("door elkaar, maak beter"): de meelopende kop verscheen pas als de hele kolomkop weg was, zodat
      // je ongeveer 130px scrolde zonder één productnaam. Nu zodra de bovenkant van de titel onder de kop schuift.
      const titel = this.koppen.querySelector('.banky-vergelijk__titel');
      const ref = titel ? titel.getBoundingClientRect().top : this.koppen.getBoundingClientRect().bottom;
      const tabel = this.schuif.getBoundingClientRect();
      const aan = ref < boven && tabel.bottom > boven + 180;
      if (aan !== this.plak.classList.contains('is-zichtbaar')) {
        this.plak.classList.toggle('is-zichtbaar', aan);
        this.plak.toggleAttribute('inert', !aan);
        // Controle 03-10: zolang de plak staat de oorspronkelijke namen onzichtbaar (CSS), anders stonden ze bij omhoog
        // scrollen boven en door de glazen kop heen, met dezelfde namen in de plak eronder.
        this.koppen.classList.toggle('is-geplakt', aan);
      }
      // Zolang de kop schuift (animatie of CSS-overgang op store-header) elke frame opnieuw: plek en zichtbaarheid
      // volgen de kop, in plaats van één meting na een vaste wachttijd (02-10). Na afloop nog één frame.
      const schuift = !!(header && header.getAnimations && header.getAnimations().some(a => a.playState === 'running'));
      if (schuift) this.plakNa = 1;
      if (schuift || this.plakNa > 0) { if (!schuift) this.plakNa--; this.plakPlan(); }
    }

    // Op mobiel schuift de meelopende kolomkop mee met de tabel.
    spiegel() {
      if (!this.plakRij || !this.schuif) return;
      const x = this.schuif.scrollLeft || 0;
      this.plakRij.style.transform = x ? `translateX(${-x}px)` : '';
    }
  }

  if (!customElements.get('banky-compare-tray')) customElements.define('banky-compare-tray', BankyCompareTray);
  if (!customElements.get('banky-vergelijk')) customElements.define('banky-vergelijk', BankyVergelijk);
  window.BankyVergelijken = {leesKeuze, schrijfKeuze};
})();
